import { TableAsyncSelect } from 'common/components/table-filter-component';
import { QUERY_COUNTRY } from './queries';
import React, { useState } from 'react';
import { message, Select, Spin } from 'antd';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

export const CountryFilter = ({ field, ...rest }) => {
  const [queryFilter, setQueryFilter] = useState({
    fullName: null,
    referenceId: null,
    externalId: null,
    registeredPhone: null,
    emailAddress: null,
    partnerCodes: [],
    sourceCountryCodes: [],

    countrySearchKeyword: null,
    partnerCodeSearchKeyword: null,
  });

  const { loading: searchCountryLoading, data: searchCountryResponse } = useQuery(QUERY_COUNTRY, {
    variables: {
      pageNumber: 1,
      pageSize: 100,
      name: queryFilter.countrySearchKeyword,
    },
    onError: e => {
      message.error(e?.toString());
    },
  });
  const searchCountryResult = searchCountryResponse?.countries?.edges?.map(edge => ({
    label: edge.node.name,
    value: edge.node.countryCode,
  }));

  return (
    <TableAsyncSelect
      field={field || 'sourceCountry'}
      isMulti
      loading={searchCountryLoading}
      value={queryFilter.sourceCountryCodes || []}
      list={searchCountryResult}
      onInput={value => setQueryFilter(current => ({ ...current, countrySearchKeyword: value }))}
      fetching={searchCountryLoading}
      onChange={(_fieldName, value) => {
        const countryIds = value.length ? value : [];
        setQueryFilter(current => ({ ...current, sourceCountryCodes: countryIds }));
      }}
      {...rest}
    />
  );
};

export const CountryFilterSelect = ({ onChange, ...rest }) => {
  const { t } = useTranslation();
  const [queryFilter, setQueryFilter] = useState({
    sourceCountryCodes: [],
    countrySearchKeyword: null,
  });
  const { loading: searchCountryLoading, data: searchCountryResponse } = useQuery(QUERY_COUNTRY, {
    variables: {
      pageNumber: 1,
      pageSize: 100,
      name: queryFilter.countrySearchKeyword,
    },
    onError: e => {
      message.error(e?.toString());
    },
  });
  const searchCountryResult = searchCountryResponse?.countries?.edges?.map(edge => ({
    label: edge.node.name,
    value: edge.node.id,
  }));
  return (
    <Select
      mode="multiple"
      filterOption={false}
      onSearch={value => setQueryFilter(current => ({ ...current, countrySearchKeyword: value }))}
      onChange={value => {
        setQueryFilter(current => ({ ...current, sourceCountryCodes: value }));
        onChange && onChange(value);
      }}
      notFoundContent={searchCountryLoading ? <Spin size="small" /> : null}
      placeholder={t('cms.reconciliation.list.table.filter.destination_market')}
      {...rest}
    >
      {searchCountryResult?.map(item => {
        return (
          <Select.Option key={item.label} value={item.value}>
            {item.label}
          </Select.Option>
        );
      })}
    </Select>
  );
};
